import { FC } from "react";
import { useTranslation } from "react-i18next";
import SectionGridFilterCard from "./SelectionGridFilterCard";
import PromoBlock from "./PromoBlock/index";
import IntroBlock from "./IntroBlock/index";
import ProductType from "./ProductType";
export interface ProductsPageProps {
	className?: string;
};

const ProductsPage: FC<ProductsPageProps> = ({ className = "" }) => {
	const { t } = useTranslation();

	return (
		<div className={`nc-ProductsPage relative ${className}`}>
			{/* 视频 */}
			<IntroBlock />
			{/* 商品分类 */}
			{/* <ProductType /> */}
			{/* 商品卡片 */}
			<SectionGridFilterCard />
			{/* 促销活动 */}
			{/* <PromoBlock heading={t('product.promotions')} leftIsImage={true} /> */}
		</div>
	)
};

export default ProductsPage;